var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 972.43 972.43",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.865,972.43h314.1l-104.4-337.601c-3.5-11.3,3.101-23.3,14.5-26.399l69.8-19l-21-51.101 c-142.399,12.9-260.5,120-285.2,263.3l-22.3,129.9C91.665,952.93,108.165,972.43,129.865,972.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.465,538.229l-21,51.1l69.8,19c11.4,3.101,18,15.101,14.5,26.4l-104.3,337.7h314.1c21.699,0,38.199-19.601,34.5-40.9 l-22.4-130C829.965,658.229,711.965,551.129,569.465,538.229z M763.364,866.629H647.565c-14,0-21-16.899-11.1-26.899l57.898-57.9 c6.102-6.1,16.102-6.1,22.301,0l57.9,57.9C784.364,849.729,777.364,866.629,763.364,866.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.165,504.729c125.1,0,226.5-101.4,226.5-226.5v-223.4c0-36.2-34.499-62.5-69.399-52.8l-280.8,77.4 c-60.8,16.8-102.8,72-102.8,135v63.7C259.665,403.329,361.064,504.729,486.165,504.729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.364,641.93v51c0,18.8,20,30.899,36.7,22.1l69.101-36.5l69.1,36.5c16.6,8.8,36.7-3.3,36.7-22.1v-51 c0-18.801-20-30.9-36.7-22.101l-69.1,36.5l-69.101-36.5C400.364,611.029,380.364,623.129,380.364,641.93z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroom);
export default __webpack_public_path__ + "static/media/groom.ee6071b34b6059aef55b6b8b149365c6.svg";
export { ForwardRef as ReactComponent };